import { Outlet } from 'react-router-dom'

import { AvailableModules } from 'generated/featureDefinitions'
import { SoftwareManagementRootPageQueryDocument } from 'generated/resources/graphql'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import { AccountsPayableUpsellModal } from 'modules/finance/components/AccountsPayableUpsellModal'
import CollectionsBootstrap from 'modules/software_management/lib/CollectionsBootstrap'

const DEFAULT_CURRENCY = 'USD'

const Container = () => {
  const { company, employee } = useCurrentSession()

  const { data, loading } = useQuery(SoftwareManagementRootPageQueryDocument, {
    variables: { companyId: company.id, moduleId: AvailableModules.it_management },
  })

  if (loading) {
    return null
  }

  const userCurrency = employee?.legalEntity?.currency || company.currency

  const exchangeCurrencies = data?.finance.exchangeCurrenciesConnection.nodes || []
  const currencyAvailable = exchangeCurrencies.some((currency) => currency.id === userCurrency)
  const moduleAvailable = data?.companies.moduleAvailabilities[0]?.available ?? false
  const canManageSoftware = data?.softwareManagement?._policies.manageSoftware.can ?? false

  const hasAccess = () => {
    return moduleAvailable && canManageSoftware
  }

  return (
    <AuthorizeUser authorizeFn={() => hasAccess()}>
      <AccountsPayableUpsellModal source="ap_itmanagement_upsellcard"></AccountsPayableUpsellModal>
      <Outlet context={{ currency: currencyAvailable ? userCurrency : DEFAULT_CURRENCY }} />
    </AuthorizeUser>
  )
}

const RootPage = () => (
  <CollectionsBootstrap>
    <Container />
  </CollectionsBootstrap>
)

export default RootPage
